import { Booking, BookingGroup } from './firebaseApi.ts';

export type BookingGroupWithId = BookingGroup & { id: string };

export function bookingGroupsById(
  groups: BookingGroupWithId[]
): Map<string, BookingGroupWithId> {
  return new Map(groups.map((g) => [g.id, g]));
}

export function isBookingApproved(
  booking: Booking,
  groupsById: Map<string, BookingGroupWithId>
): boolean {
  if (!booking.groupId) return false;
  return groupsById.get(booking.groupId)?.approved ?? false;
}

export function getBookingKeypadCode(
  booking: Booking,
  groupsById: Map<string, BookingGroupWithId>
): string | undefined {
  if (!booking.groupId) return undefined;
  return groupsById.get(booking.groupId)?.keypadCode ?? undefined;
}

/** Resolve approved + keypadCode from BookingGroup */
export function enrichBookingWithGroup(
  booking: Booking,
  groupsById: Map<string, BookingGroupWithId>
): Booking {
  const approved = isBookingApproved(booking, groupsById);
  const keypadCode = approved ? getBookingKeypadCode(booking, groupsById) : undefined;
  return { ...booking, approved, keypadCode };
}

export function enrichBookingsWithGroups(
  bookings: Booking[],
  groups: BookingGroupWithId[]
): Booking[] {
  const groupsById = bookingGroupsById(groups);
  return bookings.map((b) => enrichBookingWithGroup(b, groupsById));
}
